export const API_EXTERNAL_ENDPOINT = 'search/seo/facet-modules'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/search/seo/facet-modules'
